import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserContextService } from 'src/app/core/services/user-context.service';
import { SubscriptionPlanService } from 'src/app/core/services/subscription-plan.service';

export interface SubscriptionRow {
  id: string;
  label: string;
  status: 'Active' | 'Pending' | 'Past Due' | 'Canceled';
  planName: string;
  users: number;
  instances: number;
  started: Date;
  billingPeriod: string;
  avgMonthlyTotal: number;
}

@Component({
  selector: 'app-subscription-list',
  templateUrl: './subscription-list.component.html',
  styleUrls: ['./subscription-list.component.css']
})
export class SubscriptionListComponent implements OnInit {
  subscriptions: SubscriptionRow[] = [];
  isLoading = true;

  constructor(
    private subscriptionService: SubscriptionPlanService,
    private userContextService: UserContextService,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    const subscriptions = this.userContextService.Subscriptions;

    if (subscriptions) {
      this.subscriptions = await Promise.all(subscriptions.map(async (sub) => {
        const { amount, billingPeriodInMonths } = this.subscriptionService.CalculateRecuringInvoiceAmount(sub);
        const avgMonthlyTotal = amount / billingPeriodInMonths;
        const billingPeriod = this.subscriptionService.GetBillingCycle(sub).Name;
        return {
          id: sub.ID,
          label: sub.Label && sub.Label.trim().length ? sub.Label : 'No Label',
          status: sub.Status as 'Active' | 'Pending' | 'Past Due' | 'Canceled',
          planName: (await sub.GetPlan()).Name || 'Unknown Plan',
          users: sub.CurrentUserCount,
          instances: sub.InstanceCount ? sub.InstanceCount : 0,
          started: new Date(sub.StartDate),
          billingPeriod: billingPeriod,
          avgMonthlyTotal
        };
      }))
    }

    this.isLoading = false;
  }
  

  onSelectSubscription(sub: SubscriptionRow): void {
    // Navigate to the subscription details page using the subscription id.
    this.router.navigate(['/settings/subscription', sub.id, 'details']);
  }

  getStatusClass(status: SubscriptionRow['status']): string {
    switch (status) {
      case 'Active':
        return 'status-active';
      case 'Pending':
        return 'status-pending';
      case 'Past Due':
        return 'status-past-due';
      case 'Canceled':
        return 'status-canceled';
      default:
        return '';
    }
  }
}